var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client"},[_c('img',{staticClass:"client__logo-img",attrs:{"src":_vm.client.ClientLogo.File.Url,"alt":_vm.client.ClientName}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65871b30","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./WebResources/vue/grad-images/home/index/components/ContentItems/FeaturedClient.vue
// module id = 1691
// module chunks = 10